import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "./ui/button";
import { SITE, STATS } from "../data/mock";
import { PHOTOS } from "../data/photos";

const Hero = () => {
  return (
    <section
      id="home"
      className="relative pt-[140px] md:pt-[180px] pb-20 md:pb-28 overflow-hidden rc-hero-accent"
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_top,_#fbf9fc_0%,_#ffffff_60%)]"
      />

      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7 rc-reveal">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-[hsl(var(--border))] bg-white text-[12px] tracking-[0.14em] uppercase text-[hsl(var(--rc-purple))] font-medium">
              <span className="w-1.5 h-1.5 rounded-full bg-[hsl(var(--rc-gold))]" />
              Peer-led recovery support
            </div>

            <h1 className="font-serif-display mt-6 text-[44px] sm:text-[56px] lg:text-[72px] leading-[1.02] font-semibold text-[hsl(var(--rc-deep))]">
              Together <span className="italic text-[hsl(var(--rc-purple))]">we</span>
              <br />
              <span className="text-[hsl(var(--rc-charcoal))]">recover.</span>
            </h1>

            <p className="mt-6 text-[17px] md:text-[18px] leading-[1.7] text-[hsl(var(--rc-slate))] max-w-2xl">
              Recovery Connections of Central Florida is a nonprofit Recovery Community Organization led by people in recovery. Our Certified Recovery Peer Specialists provide compassionate, personalized support — connecting individuals and families to multiple pathways for long-term, sustainable recovery.
            </p>

            <div className="mt-9 flex flex-col sm:flex-row gap-3.5">
              <Button asChild size="lg" className="bg-[hsl(var(--rc-deep))] hover:bg-[hsl(var(--rc-purple))] text-white rounded-full h-12 px-6 group">
                <Link to="/need-help" className="flex items-center">
                  Find Your Path
                  <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-full h-12 px-6 border-[hsl(var(--border))] hover:border-[hsl(var(--rc-purple))] hover:bg-[hsl(var(--rc-purple-soft))] text-[hsl(var(--rc-charcoal))]">
                <a href={`tel:${SITE.helplineTel}`} className="flex items-center">
                  <Phone className="w-4 h-4 mr-2" />
                  {SITE.helpline}
                </a>
              </Button>
            </div>

            <p className="mt-5 text-[13px] text-[hsl(var(--muted-foreground))]">
              Recovery must come first — so that everything you love in life doesn’t have to come last.
            </p>
          </div>

          <div className="lg:col-span-5 relative rc-reveal" style={{ animationDelay: "120ms" }}>
            <div className="relative aspect-[4/5] w-full max-w-[460px] mx-auto">
              <img
                src={PHOTOS.couchTalk}
                alt="Three people in a candid conversation"
                className="absolute inset-0 w-full h-full object-cover rounded-[20px] shadow-[0_30px_80px_-30px_rgba(60,40,90,0.45)]"
              />
              <div aria-hidden className="absolute -inset-3 -z-10 rounded-[24px] border border-[hsl(var(--rc-purple-soft))]" />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl px-5 py-4 shadow-[0_18px_40px_-18px_rgba(60,40,90,0.25)] border border-[hsl(var(--border))] hidden sm:block">
                <div className="text-[11px] tracking-[0.16em] uppercase text-[hsl(var(--muted-foreground))]">
                  Helpline
                </div>
                <div className="text-[18px] font-semibold text-[hsl(var(--rc-deep))]">
                  {SITE.helpline}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-10 border-t border-[hsl(var(--border))] pt-10">
          {STATS.map((s) => (
            <div key={s.label}>
              <div className="font-serif-display text-[34px] md:text-[40px] font-semibold text-[hsl(var(--rc-deep))]">
                {s.value}
              </div>
              <div className="mt-1 text-[13px] text-[hsl(var(--muted-foreground))]">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
